import PageShell from "../components/PageShell";
import PageHeader from "../components/PageHeader";
import RegrasGrid from "../components/RegrasGrid";
import { REGRAS_PAGO } from "../data/staffData";

export default function RegrasPago() {
    return (
        <PageShell testid="page-regras-pago">
            <PageHeader
                eyebrow="Regras Staff Pagos"
                title="Regras Específicas — Staff Pago"
                description="As 5 regras específicas para Staffs pagos. O pagamento do cargo não concede privilégios, imunidade ou permanência garantida na equipe."
            />
            <RegrasGrid
                regras={REGRAS_PAGO}
                accent="#F59E0B"
                searchTestid="search-input-regras-pago"
                cardPrefix="rule-card-pago"
                placeholder="Buscar regra por título ou conteúdo..."
            />
        </PageShell>
    );
}
